import { render, staticRenderFns } from "./DiscoverFilters.vue?vue&type=template&id=8a483036&scoped=true&"
import script from "./DiscoverFilters.vue?vue&type=script&lang=ts&"
export * from "./DiscoverFilters.vue?vue&type=script&lang=ts&"
import style0 from "./DiscoverFilters.vue?vue&type=style&index=0&id=8a483036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a483036",
  null
  
)

export default component.exports